/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShipmentCoverage
 */
export interface ShipmentCoverage {
  /**
   *
   * @type {string}
   * @memberof ShipmentCoverage
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentCoverage
   */
  reason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentCoverage
   */
  isCovered: boolean;
}

/**
 * Check if a given object implements the ShipmentCoverage interface.
 */
export function instanceOfShipmentCoverage(
  value: object,
): value is ShipmentCoverage {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("isCovered" in value) || value["isCovered"] === undefined) return false;
  return true;
}

export function ShipmentCoverageFromJSON(json: any): ShipmentCoverage {
  return ShipmentCoverageFromJSONTyped(json, false);
}

export function ShipmentCoverageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentCoverage {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    reason: json["reason"] == null ? undefined : json["reason"],
    isCovered: json["isCovered"],
  };
}

export function ShipmentCoverageToJSON(json: any): ShipmentCoverage {
  return ShipmentCoverageToJSONTyped(json, false);
}

export function ShipmentCoverageToJSONTyped(
  value?: ShipmentCoverage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    reason: value["reason"],
    isCovered: value["isCovered"],
  };
}
